import React, { ReactElement } from 'react';
import { MoreLoader } from 'lib/useFirestoreQuery';

export function LoadMoreRow({
  moreLoader,
}: {
  moreLoader: MoreLoader;
}): ReactElement {
  if (moreLoader.nothingMore) return <></>;

  return (
    <tr>
      <td className="px-6 py-4 whitespace-nowrap" colSpan={4}>
        <div className="text-center">
          {moreLoader.loadingMore ? (
            <span className="text-sm">Loading...</span>
          ) : (
            <a
              className="text-sm text-blue-500 hover:text-blue-700 hover:cursor-pointer"
              onClick={() => moreLoader.loadMore()}
            >
              Load more
            </a>
          )}
        </div>
      </td>
    </tr>
  );
}
